import { useEffect } from 'react';

import { isApplicationModeInfinity } from 'src/data/system';
// @ts-expect-error - root store doesn't have TypeScript definitions
import { useCurrentCustomerId, useTalkingPointsActions } from 'src/store';

export const useMaintainTalkingPointsStoreState = () => {
  const currentCustomerId = useCurrentCustomerId();
  const talkingPointsActions = useTalkingPointsActions();

  useEffect(() => {
    if (!currentCustomerId) return;

    // we don't need "talking points" in Infinity
    if (isApplicationModeInfinity()) {
      return;
    }

    talkingPointsActions.queryTalkingPoints();

    return () => {
      talkingPointsActions.clearStore();
    };
  }, [currentCustomerId, talkingPointsActions]);
};
